module.exports = __webpack_public_path__ + "img/Claudia_Ifea_small.90d162c4.jpg";